export default "__VITE_ASSET__C04s$SET__"